export enum AccountingUserStatusEnum {
	ACTIVE = 'ACTIVE',
	DISABLED = 'DISABLED',
}
